export default "__VITE_ASSET__BiuDZkqy__"